import { useState, useEffect } from "react";
import { Grid, Typography, Button, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  navHolder: {
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
    backgroundColor: theme.palette.secondary.main,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "flex",
    justifyContent: "flex-start",
    position: "fixed",
    zIndex: "3",
    bottom: "0px",
    width: "100%",
  },
  textHolder: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    "& span": {
      paddingRight: 10,
      textAlign: "right",
      fontSize: "1rem",
      fontWeight: 500,
      color: "#fff",
      cursor: "pointer",
    },
  },
  text: {
    color: theme.palette.text.secondary,
    fontSize: "0.825rem",
    textAlign: "center",
    "& div": {
      width: "100%",
      padding: "15px 15px 0px",
    },
    "& strong": {
      color: theme.palette.primary.main,
    },
    "& a": {
      textDecoration: "underline",
      color: theme.palette.text.secondary,
    },
  },
  highlight: {
    background: theme.palette.primary.main,
    fontWeight: 700,
    padding: "2px 10px",
  },
  button: {
    fontFamily: "Ubuntu",
    fontStyle: "normal",
    fontWeight: "normal",
    padding: "4px 24px",
    fontSize: "1rem",
    marginLeft: 0,
    backgroundColor: "rgb(77 167 71)",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#FFFFFF",
      color: "rgb(77 167 71)",
    },
    "& span": {
      paddingRight: "0",
    },
  },
  img: {
    margin: " 0 auto",
    display: "block",
    boxShadow: "-92px 90px 0px -10px rgba(255,255,255,0.2)",
    borderRadius: "100% 100% 0 100%",
    border: "5px solid #fff",
    maxwidth: "320px",
  },
}));

export default function FloatingNav() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const isClosed = localStorage.getItem("popupUnitClosed");
    setShow(!isClosed);
  }, []);

  function handleClosePopup() {
    localStorage.setItem("popupUnitClosed", true);
    setShow(false);
  }

  const { i18n } = useTranslation();
  if (i18n.language !== "pt") {
    return null;
  }
  if (show) {
    return (
      <div className={classes.navHolder}>
        <Grid
          container
          justifyContent="center"
          alignContent="center"
          spacing={4}
        >
          <Grid item className={classes.textHolder} style={{ margin: "0" }}>
            <Typography
              variant="body1"
              component="div"
              className={classes.text}
            >
              <div>
                <strong>{t("Aviso de Cookies")} | </strong>
                {t(
                  "Utilizamos cookies e outras tecnologias semelhantes para melhorar a sua experiência e aprimorar as funcionalidades do site, de acordo com a nossa"
                )}
                <a
                  href="https://vialaser.com.br/politicas-de-privacidade"
                  target="_blank"
                  rel="noopener noreferrer"
                  alt="cookies"
                >
                  {" "}
                  {t("política de privacidade")}
                </a>{" "}
                {t(
                  "e, ao continuar navegando você está de acordo com estas condições"
                )}
              </div>
            </Typography>
            <Typography variant="body1" style={{ textAlign: "center" }}>
              <span alt="Promoções">
                <Button
                  onClick={handleClosePopup}
                  onKeyPress={handleClosePopup}
                  role="button"
                  tabIndex={0}
                  style={{ margin: "10px" }}
                  className={classes.button}
                >
                  PROSSEGUIR
                </Button>
              </span>
            </Typography>
          </Grid>
        </Grid>
      </div>
    );
  }
  return null;
}
